import { ITemplate } from '../types';
import { IRestBoardForOpenDialog } from '../../../rest/types';

export const getTemplatesFromRest = (
    templates: IRestBoardForOpenDialog[]
): ITemplate[] => {
    const templatesRaw = templates.reduce((
        templatesReduce,
        template
    ) => {
        const {
            description,
            driveId,
            id,
            name,
            templateInfo
        } = template;
        if (templateInfo) {
            templatesReduce.push({
                description,
                driveId,
                id,
                name,
                templateInfo
            });
        }
        return templatesReduce;
    }, []);
    const templatesSorted = templatesRaw.sort(sortTemplates);
    return templatesSorted;
};

const sortTemplates = (
    a: ITemplate,
    b: ITemplate
): number => {
    if (a.templateInfo.orderNumber < b.templateInfo.orderNumber) return -1;
    if (a.templateInfo.orderNumber > b.templateInfo.orderNumber) return 1;
    return 0;
};
